import { useDispatch, useSelector } from 'react-redux';

import {
  CANCEL_ALL_UPLOAD_CONFIRM_TEXT,
} from '@/modules/uploaderNew/constants';

import {
  getFilesProcessingStatuses,
} from '@/modules/uploaderNew/components/MultiUploadStatusDialog/helpers';
import {
  queueSelector,
} from '@/modules/uploaderNew/redux/selectors';
import {
  showCancelUploadConfirmDialogAction,
} from '@/modules/uploaderNew/redux/slices';

function useShowCancelUploadDialog() {
  const dispatch = useDispatch();
  const q = useSelector(queueSelector);
  const { hasInProgress } = getFilesProcessingStatuses(q);
  const handleOpenConfirmDialog = (context) => {
    dispatch(
      showCancelUploadConfirmDialogAction({
        ...CANCEL_ALL_UPLOAD_CONFIRM_TEXT,
        context,
      }),
    );
  };

  return {
    hasInProgress,
    handleOpenConfirmDialog,
  };
}

export default useShowCancelUploadDialog;
